export const valueSign = (value) => {
  if (value === "margin" || value === "margin_30d" || value === "margin_30d") {
    return "%";
  } else if (
    value === "profit" ||
    value === "profit_30d" ||
    value === "buy_price" ||
    value === "sell_price" ||
    value === "30d_avg_sale" ||
    value === "maximum_cost"
  ) {
    return "€";
  }
};

export const convertToDomain = (url) => {
  const domain = new URL(url).hostname;
  const mainDomain = domain.split(".").slice(-2).join(".");
  return mainDomain;
};

export const currencyFormatter = (value) => {
  return typeof value === "number"
    ? new Intl.NumberFormat("de-DE", { currency: "EUR" }).format(value)
    : value;
};

export const formatDateToGerman = (dateString) => {
  const date = new Date(dateString);
  const germanMonths = [
    "jan",
    "feb",
    "mär",
    "apr",
    "mai",
    "jun",
    "jul",
    "aug",
    "sep",
    "okt",
    "nov",
    "dez",
  ];

  const day = date.getDate();
  const month = date.getMonth();
  return `${germanMonths[month]} ${day}`;
};

export const findObject = (inputArray, searchObject) => {
  const result = {};
  for (const obj of inputArray) {
    const key = obj.type;
    if (searchObject.hasOwnProperty(key)) {
      const value = searchObject[key];
      console.log("obj :>> ", obj);
      if (
        obj.input_type === "dropdown" ||
        obj.input_type === "dropdown_checkbox"
      ) {
        if (obj.multiple_selection) {
          if (!value) {
            result[key] = [];
            continue;
          }

          if (typeof value === "string") {
            result[key] = value.map((item) => ({
              label: item,
              value: item,
            }));
            continue;
          }

          if (
            typeof value === "object" &&
            key !== "seller" &&
            key !== "country" &&
            key !== "buy_country" &&
            key !== "country_blacklist" 
          ) {
            result[key] = value.map((item) => ({
              label: item,
              value: item,
            }));
            continue;
          }

          const data = value.map((reqVal) =>
            obj.values.find((item) => item.request_value === reqVal)
          );

          result[key] = data.map((item) => ({
            label: item?.value,
            value: item?.request_value,
          }));
        } else {
          const foundValue = obj.values.find(
            (item) => item.request_value === value
          );
          if (foundValue) {
            result[key] = {
              label: foundValue.value,
              value: value,
            };
          }
        }
      } else if (obj.input_type === "text") {
        if (obj.multiple_selection) {
          if (!value) {
            result[key] = [];
            continue;
          }

          result[key] = value.map((item) => ({
            label: item,
            value: item,
          }));
        } else {
          const num = parseFloat(value);
          let newValue = value;

          if (value && !isNaN(value)) {
            newValue = num.toFixed(2) + obj.unit;
            result[key] = {
              value: newValue,
            };
          } else {
            result[key] = {
              value: value,
            };
          }
        }
      }
    }
  }

  return result;
};

export const timestamp = (date) => {
  const newDate = new Date(date);
  const day = newDate.getDate().toString().padStart(2, "0");
  const month = (newDate.getMonth() + 1).toString().padStart(2, "0");
  const year = newDate.getFullYear().toString().slice(-2);
  const hours = newDate.getHours().toString().padStart(2, "0");
  const minutes = newDate.getMinutes().toString().padStart(2, "0");

  // let period = "AM";
  // if (hours >= 12) {
  //   period = "PM";
  //   if (hours > 12) {
  //     hours = String(hours - 12).padStart(2, "0");
  //   }
  // }

  const timestamp = `${day}.${month}.${year} | ${hours}:${minutes}`;
  return timestamp;
};

const getTimeZoneOffsetMs = (date, timeZone) => {
  const formatter = new Intl.DateTimeFormat("en-GB", {
    timeZone,
    hour12: false,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
  const parts = formatter.formatToParts(date).reduce((acc, part) => {
    if (part.type !== "literal") {
      acc[part.type] = part.value;
    }
    return acc;
  }, {});
  const asUtc = Date.UTC(
    Number(parts.year),
    Number(parts.month) - 1,
    Number(parts.day),
    Number(parts.hour),
    Number(parts.minute),
    Number(parts.second)
  );
  return asUtc - date.getTime();
};

const parseBerlinIsoToLocalDate = (isoString) => {
  if (typeof isoString !== "string") {
    return null;
  }
  const match = isoString.match(
    /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?/
  );
  if (!match) {
    return null;
  }
  const [, year, month, day, hour, minute, second = "0"] = match;
  const utcGuess = new Date(
    Date.UTC(
      Number(year),
      Number(month) - 1,
      Number(day),
      Number(hour),
      Number(minute),
      Number(second)
    )
  );
  const offsetMs = getTimeZoneOffsetMs(utcGuess, "Europe/Berlin");
  const utcMs =
    Date.UTC(
      Number(year),
      Number(month) - 1,
      Number(day),
      Number(hour),
      Number(minute),
      Number(second)
    ) - offsetMs;
  return new Date(utcMs);
};

export const formatBerlinPingTimestamp = (isoString) => {
  const localDate = parseBerlinIsoToLocalDate(isoString);
  const now = new Date();
  const isToday =
    localDate &&
    localDate.getFullYear() === now.getFullYear() &&
    localDate.getMonth() === now.getMonth() &&
    localDate.getDate() === now.getDate();
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  const isYesterday =
    localDate &&
    localDate.getFullYear() === yesterday.getFullYear() &&
    localDate.getMonth() === yesterday.getMonth() &&
    localDate.getDate() === yesterday.getDate();

  const formatTime = (date) => {
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    return `${hours}:${minutes}`;
  };

  const formatDate = (date) => {
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear().toString().slice(-2);
    return `${day}.${month}.${year}`;
  };

  if (localDate) {
    const time = formatTime(localDate);
    if (isToday) {
      return time;
    }
    if (isYesterday) {
      return `Gestern um ${time}`;
    }
    return `${formatDate(localDate)} | ${time}`;
  }

  if (typeof isoString !== "string") {
    return isoString;
  }
  const trimmed = isoString.trim();
  const dateTimeMatch = trimmed.match(
    /^(\d{2})[.\-](\d{2})(?:[.\-](\d{2,4}))?\s+(\d{2}:\d{2})(?::\d{2})?$/
  );
  if (dateTimeMatch) {
    const [, day, month, yearPart, time] = dateTimeMatch;
    const currentYear = now.getFullYear();
    const normalizedYear = yearPart
      ? yearPart.length === 2
        ? Number(`20${yearPart}`)
        : Number(yearPart)
      : currentYear;
    const assumedDate = new Date(
      normalizedYear,
      Number(month) - 1,
      Number(day)
    );
    if (
      assumedDate.getFullYear() === now.getFullYear() &&
      assumedDate.getMonth() === now.getMonth() &&
      assumedDate.getDate() === now.getDate()
    ) {
      return time;
    }
    if (
      assumedDate.getFullYear() === yesterday.getFullYear() &&
      assumedDate.getMonth() === yesterday.getMonth() &&
      assumedDate.getDate() === yesterday.getDate()
    ) {
      return `Gestern um ${time}`;
    }
    return `${formatDate(assumedDate)} | ${time}`;
  }
  return trimmed;
};

export function isImageURL(url) {
  return(url.match(/\.(jpeg|jpg|gif|png)$/) != null);
}

export function isURL(string) {
  let url
  try {
    url = new URL(string)
  } catch (_) {
    return false
  }

  return url.protocol === 'http:' || url.protocol === 'https:'
}
